import { useMutation } from '@tanstack/react-query';

import { $api, errorHandler } from '../../global';

export const usePostOTMQuizTest = () =>
  useMutation({
    mutationFn: async (answers?: string[]) => {
      const { data } = await $api.post('/quiz-test', {
        answers
      });

      return data;
    },
    onError: errorHandler()
  });
